var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { style: { height: "100%", padding: "10px" } },
    [
      _c("app-calendar-list-header", {
        on: {
          refresh: function ($event) {
            return _vm.refresh()
          },
          "new-google-calendar": function ($event) {
            return _vm.newGoogleCalendar()
          },
          "new-calendar": function ($event) {
            return _vm.newCalendar()
          },
        },
      }),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "transition-group",
                { attrs: { name: "list-transition" } },
                [
                  _vm._l(_vm.calendars, function (item, i) {
                    return _c("app-local-calendar-list-item", {
                      key: item.ID,
                      ref: "calendarItems",
                      refInFor: true,
                      attrs: {
                        calendar: item,
                        active: _vm.isCalendarActive(item),
                      },
                      on: {
                        delete: function ($event) {
                          return _vm.calendarDeleted(item, i)
                        },
                        edit: function ($event) {
                          return _vm.editCalendar(item)
                        },
                        load: function ($event) {
                          return _vm.loadCalendar(item)
                        },
                      },
                    })
                  }),
                  _vm.calendars.length == 0
                    ? _c(
                        "div",
                        { key: "no-calendars", staticClass: "empty-list" },
                        [_vm._v(" " + _vm._s(_vm.$ct("no-calendars")) + " ")]
                      )
                    : _vm._e(),
                  _vm.showTaskFolders
                    ? _c("h2", { key: "tasks-header" }, [
                        _vm._v(" " + _vm._s(_vm.$ct("tasks")) + " "),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.taskFolders, function (item) {
                    return _c("app-task-folder-list-item", {
                      key: "task-folder-" + item.FolderID,
                      attrs: {
                        folder: item,
                        active: _vm.isTaskFolderActive(item),
                      },
                      on: {
                        load: function ($event) {
                          return _vm.loadTaskFolder(item)
                        },
                      },
                    })
                  }),
                  _vm.googleLoggedIn
                    ? _c("h2", { key: "header" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$ct("google-calendars", {
                                email: _vm.googleCalendarEmail,
                              })
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.googleCalendars, function (item) {
                    return _c("app-google-calendar-list-item", {
                      key: item.id,
                      attrs: {
                        calendar: item,
                        active: _vm.isGoogleCalendarActive(item),
                      },
                      on: {
                        delete: function ($event) {
                          return _vm.googleCalendarDeleted(item)
                        },
                        edit: function ($event) {
                          _vm.toEditGoogleCalendar = item
                        },
                        load: function ($event) {
                          return _vm.loadGoogleCalendar(item)
                        },
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.googleLoggedIn && _vm.isDemo
        ? _c(
            "button",
            {
              staticClass: "social-login google-login-button mt",
              on: {
                click: function ($event) {
                  return _vm.googleLogin()
                },
              },
            },
            [
              _c("img", {
                staticClass: "google-logo",
                attrs: {
                  alt: "Google logo",
                  src: require("@/assets/img/btn_google_light_normal.svg"),
                },
              }),
              _c("w-spacer"),
              _vm._v(" " + _vm._s(_vm.$ct("google-login")) + " "),
              _c("w-spacer"),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditCalendar != null } },
        [
          _vm.toEditCalendar
            ? _c("app-calendar-edit-modal", {
                attrs: { value: _vm.toEditCalendar },
                on: {
                  input: function ($event) {
                    return _vm.calendarSaved($event)
                  },
                  close: function ($event) {
                    _vm.toEditCalendar = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditGoogleCalendar != null } },
        [
          _c("app-google-calendar-edit-modal", {
            attrs: { value: _vm.toEditGoogleCalendar },
            on: {
              input: function ($event) {
                return _vm.googleCalendarSaved($event)
              },
              close: function ($event) {
                _vm.toEditGoogleCalendar = null
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }